// extracted by mini-css-extract-plugin
export default {"formContainer":"UserForm_formContainer__zgs9b","form":"UserForm_form__Kyd-7","label":"UserForm_label__hz-3l","required":"UserForm_required__nLpWC"};